import { get, post } from './common';
import { ModuleData } from '../Types/containerV2';

const endpoint = 'api/SegmentPassword';
export type SegmentPasswordEntry = { id: number; name: string; active: boolean; revision: number };
export type SegmentPasswordSettings = { enabled: boolean; entries: SegmentPasswordEntry[] };
export type SegmentPasswordSave = {
	containerId: number;
	moduleId: number;
	id: number;
	name: string;
	password?: string;
	active: boolean;
};

export const getSegmentPasswordSettings = (containerId: number, moduleId: number) =>
	get<SegmentPasswordSettings>(`${endpoint}/GetSettings?containerId=${containerId}&moduleId=${moduleId}`);
export const saveSegmentPassword = (request: SegmentPasswordSave) => post(`${endpoint}/SaveEntry`, request);
export const setSegmentProtection = (request: { containerId: number; moduleId: number; enabled: boolean }) =>
	post<{ enabled: boolean }>(`${endpoint}/SetProtection`, request);
export const unlockSegment = (request: { containerId: number; moduleId: number; password: string }) =>
	post<{ unlocked: boolean }>(`${endpoint}/Unlock`, request);
export const getProtectedSegment = (containerId: number, moduleId: number) =>
	get<{ module: ModuleData | null; expiresUtc: string | null }>(
		`${endpoint}/GetContent?containerId=${containerId}&moduleId=${moduleId}`
	);

// Translate the existing API's validation messages without changing its response contract.
const errorKeys: Record<string, string> = {
	'Use a unique name of 1–100 characters.': 'UNIQUE_NAME',
	'A segment supports at most 20 passwords.': 'MAX_PASSWORDS',
	'Enter a password when creating or reactivating an entry.': 'PASSWORD_REQUIRED',
	'This password is already used by another active entry.': 'DUPLICATE_PASSWORD',
	'Add an active password before enabling protection.': 'ACTIVE_REQUIRED',
	'Enter a password of 1–256 characters.': 'PASSWORD_LENGTH',
	'Password-protected segments cannot be nested.': 'NESTED',
	'Segment not found.': 'NOT_FOUND',
};

export const getSegmentPasswordErrorKey = (message: string | null) =>
	message === 'Too many attempts. Try again in ten minutes.'
		? 'SEGMENT_PASSWORD.LIMIT'
		: 'SEGMENT_PASSWORD_ADMIN.' +
			(message && Object.prototype.hasOwnProperty.call(errorKeys, message) ? errorKeys[message] : 'ERROR');
